import { Component, OnInit } from '@angular/core';
import { SiteproviderService } from '../../services/siteprovider.service';
import { PdfViewerModule } from 'ng2-pdf-viewer';

@Component({
  selector: 'app-resume',
  imports: [ PdfViewerModule ],
  templateUrl: './resume.component.html',
  styleUrl: './resume.component.scss'
})

export class ResumeComponent implements OnInit{
  pdfData?: any;
  currentPage = 1;
  totalPages = 1;
  service!: SiteproviderService;

  constructor(private _sps: SiteproviderService) {
    this.service = _sps;
  }

  ngOnInit() {

    // On initiation, get the PDF from the assets folder
    this.pdfData = this.service.getPDF();
  }
}
